import cronstrue from 'cronstrue';
import 'cronstrue/locales/sv.js';
import 'cronstrue/locales/fi.js';

const SUPPORTED_CRON_LOCALES = new Set(['en', 'sv', 'fi']);

/**
 * Map Helix locale to a cronstrue-supported locale code.
 *
 * @param {string | null | undefined} locale
 * @returns {'en' | 'sv' | 'fi'}
 */
export function resolveCronLocale(locale) {
  const normalized = String(locale ?? 'en')
    .split('-')[0]
    .toLowerCase();
  return SUPPORTED_CRON_LOCALES.has(normalized) ? normalized : 'en';
}

/**
 * Convert a cron expression to human-readable text in the given locale.
 *
 * @param {string | null | undefined} expression
 * @param {string | null | undefined} locale
 * @returns {string}
 */
export function describeCronExpression(expression, locale) {
  if (expression === null || expression === undefined || expression === '') return '—';

  const trimmed = String(expression).trim();
  if (!trimmed) return '—';

  try {
    return cronstrue.toString(trimmed, {
      locale: resolveCronLocale(locale),
      use24HourTimeFormat: true,
    });
  } catch {
    return trimmed;
  }
}
